<template>
  <section :style="styles">
    {{ title }}
  </section>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'name',
		},
		width: {
			type: String,
			default: 'unset',
		},
		height: {
			type: String,
			default: 'unset',
		},
		fontSize: {
			type: String,
			default: '12px',
		},
		padding: {
			type: String,
			default: '5px',
		},
		whiteSpace: {
			type: String,
			default: 'nowrap',
		},
		borderRadius: {
			type: String,
			default: '20px',
		},
		marginBottom: {
			type: String,
			default: '0px',
		},
		color: {
			type: String,
			default: '#4caf50',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		}
	},
	computed: {
		styles() {
			return {
				width: this.width,
				height: this.height,
				fontSize: this.fontSize,
				backgroundColor: `${this.color}31`,
				whiteSpace: this.whiteSpace,
				padding: this.padding,
				borderRadius: this.borderRadius,
				color: this.color,
				fontWeight: this.fontWeight,
				marginBottom: this.marginBottom,
			};
		}
	}
};
</script>

<style>

</style>
